module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('quest-search', {
    attrs: {
      "id": "search"
    },
    on: {
      "input": _vm.updateQuest
    }
  })], 1)]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n      Selected Quest\n    ")]), _vm._v(" "), _c('quest', {
    attrs: {
      "slug": _vm.slug
    },
    on: {
      "nav": function (x) {
        _vm.selected = x
      }
    }
  })], 1), _vm._v(" "), (_vm.selected) ? _c('div', {
    staticClass: "column is-half"
  }, [_c('quest', {
    attrs: {
      "slug": _vm.selected
    },
    on: {
      "nav": function (x) {
        _vm.selected = x
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b5007d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Explorer.vue
// module id = 138
// module chunks = 1